import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Paper from '@material-ui/core/Paper'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {
  faChevronRight,
  faTimes,
  faCheck
} from '@fortawesome/fontawesome-free-solid'
import { faQuestionCircle } from '@fortawesome/fontawesome-free-regular'
import CircularProgress from '@material-ui/core/CircularProgress'

import * as configActions from '../../../actions/Config'
import * as bookingSystemBookingActions from '../../../actions/BookingSystemBookings'
import * as Functions from '../../../helpers/Functions'
import * as Constants from '../../../helpers/Constants'
import * as Styles from './styles'
import * as Strings from './strings'

const AVAILABLE = 'available'
const BOOKED_BY_ME = 'booked_by_me'
const OCCUPIED = 'occupied'

class BookingSystemItems extends Component {
  state = {
    hover: null
  }

  requestBookTime(timeId) {
    const { config, user, system, date } = this.props

    this.props.showAlert(
      Strings.default.REQUEST_BOOK_TIME[config.language],
      Strings.default.REQUEST_BOOK_TIME_INFO[config.language],
      Constants.TWO_BUTTONS,
      {
        title: Strings.default.NO[config.language],
        onPress: () => {}
      },
      {
        title: Strings.default.YES[config.language],
        onPress: () => {
          const data = { timeId, date }

          this.props.tryCreateBookingForBookingSystem(
            user.token,
            system.id,
            data,
            user.offlineModeSignedIn,
            (h, i, t, b) => this.props.showAlert(h, i, t, b),
            config.language
          )
        }
      }
    )
  }

  requestUnbookTime(id) {
    const { config, user, system } = this.props

    this.props.showAlert(
      Strings.default.REQUEST_UNBOOK_TIME[config.language],
      Strings.default.REQUEST_UNBOOK_TIME_INFO[config.language],
      Constants.TWO_BUTTONS,
      {
        title: Strings.default.NO[config.language],
        onPress: () => {}
      },
      {
        title: Strings.default.YES[config.language],
        onPress: () =>
          this.props.tryDeleteBookingForBookingSystem(
            user.token,
            system.id,
            id,
            user.offlineModeSignedIn
          )
      }
    )
  }

  alertOccupiedTime(booking) {
    const { config, data } = this.props
    console.log('Debug - showApartmentInLaundry:', data.showApartmentInLaundry)
    console.log('Debug - booking:', booking)
    console.log('Debug - booking.apartment:', booking && booking.apartment)
    
    const showApartmentInfo = data.showApartmentInLaundry !== false
    const apartmentNumber = showApartmentInfo && booking && booking.apartment ? booking.apartment.number : ''
    const apartmentAddress = showApartmentInfo && booking && booking.apartment ? booking.apartment.address : ''

    console.log('Debug - showApartmentInfo:', showApartmentInfo)
    console.log('Debug - apartmentNumber:', apartmentNumber)
    console.log('Debug - apartmentAddress:', apartmentAddress)

    this.props.showAlert(
      Strings.default.OCCUPIED_ALERT_HEADER[config.language],
      apartmentNumber 
        ? Strings.default.OCCUPIED_BY_ALERT[config.language]
            .replace('{apartmentNumber}', apartmentNumber)
            .replace(apartmentAddress ? '{apartmentAddress}' : ' {apartmentAddress}', apartmentAddress ? ` ${apartmentAddress}` : '')
        : Strings.default.OCCUPIED_ALERT[config.language],
      Constants.ONE_BUTTON,
      { title: Strings.default.OK[config.language], onPress: () => {} }
    )
  }

  isCreating(timeId) {
    const { date, bookingSystemBookings } = this.props
    const { isCreating } = bookingSystemBookings

    for (let i = 0; i < isCreating.length; i++) {
      if (isCreating[i].timeId === timeId && isCreating[i].date === date) {
        return true
      }
    }

    return false
  }

  render() {
    const { hover } = this.state
    const { system, date, config, bookingSystemBookings, data } = this.props


    const times = system.times.filter(
      time => !Functions.timePassed(date, time.end)
    )

    if (times.length === 0) {
      return <p>{Strings.default.NO_TIMES_TODAY[config.language]}</p>
    }

    return times
      .sort((o1, o2) => (o1.start > o2.start ? 1 : -1))
      .map(time => {
        let status = AVAILABLE
        let onClick = () => this.requestBookTime(time.id)
        let loading = this.isCreating(time.id)
        const bookings = time.bookings.filter(
          booking =>
            Functions.parseDate(date) ===
            Functions.parseDate(new Date(booking.date))
        )

        if (
          bookings.length !== 0 &&
          bookings[0].apartmentId === data.apartment.id
        ) {
          status = BOOKED_BY_ME
          onClick = () => this.requestUnbookTime(bookings[0].id)
          loading =
            bookingSystemBookings.isDeleting.indexOf(bookings[0].id) !== -1
        } else if (bookings.length !== 0) {
          status = OCCUPIED
          onClick = () => this.alertOccupiedTime(bookings[0])
          loading = false
        }

        return (
          <TimeItem
            key={time.id}
            time={time.start + '-' + time.end}
            status={status}
            language={config.language}
            onMouseEnter={() => this.setState({ hover: time.id })}
            onMouseLeave={() => this.setState({ hover: null })}
            hover={time.id === hover}
            onClick={() => onClick()}
            loading={loading}
            apartmentNumber={bookings.length !== 0 && bookings[0].apartment && bookings[0].apartment.number ? bookings[0].apartment.number : null}
          />
        )
      })
  }
}

const TimeItem = ({
  time,
  status,
  language,
  onMouseEnter,
  onMouseLeave,
  hover,
  onClick,
  loading,
  apartmentNumber
}) => {
  let color = Constants.WHITE_LABEL.colors.primary
  let hoverColor = Constants.WHITE_LABEL.colors.primaryHover
  let text = Strings.default.AVAILABLE[language]
  let icon = faChevronRight

  if (status === BOOKED_BY_ME) {
    text = Strings.default.BOOKED_BY_ME[language]
    icon = faCheck
  } else if (status === OCCUPIED) {
    text = Strings.default.OCCUPIED[language]
    color = Constants.WHITE_LABEL.colors.warning
    hoverColor = Constants.WHITE_LABEL.colors.warningHover
    icon = faQuestionCircle
  }

  return (
    <Paper
      style={Styles.default.container}
      className={'hover'}
      onMouseEnter={() => onMouseEnter()}
      onMouseLeave={() => onMouseLeave()}
      onClick={() => (loading ? {} : onClick())}
    >
      <div style={Styles.default.innerContainer}>
        <p style={Styles.default.text}>{time}</p>
      </div>
      {loading ? (
        <CircularProgress style={{ color }} thickness={2} size={30} />
      ) : (
        <div style={Styles.default.iconContainer}>
          <p
            style={{
              ...Styles.default.iconText,
              color: hover ? hoverColor : color
            }}
          >
            {text}
          </p>
          <FontAwesomeIcon
            icon={icon}
            style={{
              ...Styles.default.icon,
              color: hover ? hoverColor : color
            }}
          />
        </div>
      )}
    </Paper>
  )
}

function mapStateToProps({ user, config, bookingSystemBookings, data }) {
  return { user, config, bookingSystemBookings, data }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...bookingSystemBookingActions },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookingSystemItems)



// WEBPACK FOOTER //
// ./src/components/containers/BookingSystemItems/index.js